import dotObject from 'dot-object';

export default function finalFormErrorHandler(error, errorHandler, invalidHandler) {
  if (error.response.status === 422) {
    const { errors } = error.response.data;

    if (invalidHandler) {
      invalidHandler(error);
    }

    return dotObject.object({...errors});
  }
  if (!errorHandler) {
    errorHandler = function(error) {
      window.alert('Er is een onbekende fout opgetreden.');
      throw error;
    };
  }
  return errorHandler(error);
}
